import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'btn bg-white shadow hover:bg-primary/90 hover:text-black [&>svg]:stroke-black',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
        outline:
          'btn border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
        'outline-post':
          'btn border border-input border-white/20 bg-foreground/20 text-white hover:bg-foreground/30 hover:border-white/30',
        'outline-post-secondary':
          'btn border border-secondary/50 bg-secondary/10 text-secondary hover:bg-secondary/20 hover:border-secondary/70',
        secondary: 'btn bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
        ghost: 'hover:bg-white hover:text-accent-foreground bg-white/20',
        inverse: 'border border-white/20 hover:bg-white/10 hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        default: 'h-9 px-4 py-5',
        xs: 'h-7 rounded px-2',
        sm: 'h-8 rounded-md px-3 text-xs',
        md: 'h-9 rounded-md px-4',
        lg: 'h-10 rounded-md px-8',
        icon: 'h-9 w-9',
      },
      borderRadius: {
        none: 'rounded-none',
        sm: 'rounded-sm',
        md: 'rounded-md',
        lg: 'rounded-lg',
        full: 'rounded-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      borderRadius: 'md',
    },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
